export const rankingItems = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子，酒店共度8小时', heat: '987万', tag: '爆', time: '2小时前' },
  { rank: 2, title: '知名导演被曝片场耍大牌，多次辱骂工作人员录音曝光', heat: '856万', tag: '热', time: '4小时前' },
  { rank: 3, title: '当红小花与前经纪公司解约内幕，千万违约金细节流出', heat: '742万', tag: '热', time: '5小时前' },
  { rank: 4, title: '某综艺节目黑幕大起底，选手晋级名单早已内定', heat: '631万', tag: '新', time: '6小时前' },
  { rank: 5, title: '豪门婚礼变闹剧，新娘当场揭露新郎出轨聊天记录', heat: '528万', tag: '热', time: '7小时前' },
  { rank: 6, title: '某品牌代言人塌房，品牌方连夜撤下所有宣传物料', heat: '415万', tag: '新', time: '8小时前' },
  { rank: 7, title: '网红主播偷税被罚，补缴税款及滞纳金超5000万', heat: '387万', tag: '新', time: '9小时前' },
];

export const featuresItems = [
  { icon: 'ri-flashlight-line', title: '全网最快', desc: '7×24小时实时监控各大社交平台，热点事件发生后最快3分钟内完成核实与推送，让您永远比朋友圈早一步知道。' },
  { icon: 'ri-spy-line', title: '独家信源', desc: '拥有覆盖娱乐圈、商圈、网红圈的深度信源网络，一手内幕消息直达编辑团队，确保每条爆料都有据可查。' },
  { icon: 'ri-shield-check-line', title: '安全浏览', desc: '采用多层隐私保护技术，浏览记录不存储、不追踪、不泄露。安全进入爆料平台首页，放心看最新独家内容。' },
  { icon: 'ri-group-line', title: '万人吃瓜', desc: '活跃社区日均百万用户在线互动，每条爆料下都有真实网友热评、分析、补充，让吃瓜不再是一个人的孤独。' },
];

export const indexItems = [
  { title: '顶流塌房实录', desc: '那些年突然翻车的顶流们', count: 236, icon: 'ri-alert-line' },
  { title: '豪门恩怨', desc: '有钱人的世界你不懂', count: 189, icon: 'ri-vip-crown-line' },
  { title: '综艺黑幕', desc: '镜头背后的残酷真相', count: 154, icon: 'ri-tv-line' },
  { title: '网红翻车', desc: '滤镜碎了一地的瞬间', count: 312, icon: 'ri-camera-off-line' },
  { title: '品牌代言风波', desc: '当明星效应变成品牌噩梦', count: 128, icon: 'ri-shopping-bag-3-line' },
  { title: '影视圈潜规则', desc: '光鲜背后的灰色地带', count: 203, icon: 'ri-film-line' },
  { title: '社会热点追踪', desc: '不止娱乐，更有态度', count: 267, icon: 'ri-fire-line' },
  { title: '国际娱乐风向', desc: '日韩欧美最新瓜讯', count: 145, icon: 'ri-global-line' },
];

export const carouselItems = [
  { title: '某选秀节目导师"潜规则"学员聊天记录全曝光', excerpt: '独家获取了某选秀节目导师与多名学员之间的私密聊天记录，内容涉及变相威胁、利益交换等多项指控，目前节目组尚未回应。事件发酵后，多位前学员发声支持爆料者...', tag: '独家', time: '2026-07-29' },
  { title: '两家头部MCN机构暗战升级，互爆对方刷量造假证据', excerpt: '国内两大头部MCN机构近日在社交平台公开互撕，双方先后放出对方刷量、买粉、数据造假的内部文件和截图，行业乱象被全面揭开，引发监管部门关注...', tag: '深度', time: '2026-07-28' },
  { title: '揭秘某短视频平台推荐算法的"流量密码"', excerpt: '从多位离职算法工程师处获取的第一手资料，详细解读该平台如何通过算法操控用户情绪、制造争议话题、定向推送争议内容以提升用户停留时长的内幕操作...', tag: '揭秘', time: '2026-07-27' },
  { title: '娱乐圈"阴阳合同"再度浮出水面，涉及金额或超十亿', excerpt: '继此前影视行业税务风波后，一份涉及多位一线明星的阴阳合同明细近日被匿名投递至本平台，合同显示部分艺人通过拆分合同、虚构业务等方式规避高额税款...', tag: '重磅', time: '2026-07-26' },
];

export const updatesItems = [
  { title: '某女星被拍到深夜前往医院，疑似进行整容修复手术', time: '10分钟前', tag: '最新' },
  { title: '知名音乐人被前员工举报长期拖欠工资及社保', time: '25分钟前', tag: '跟进' },
  { title: '某流量小生被发现与已婚女制片人在私人会所密会', time: '1小时前', tag: '实锤' },
  { title: '头部直播带货主播数据造假，直播间在线人数虚高70%', time: '2小时前', tag: '数据' },
  { title: '某影视公司CEO被限制高消费，多部待播剧或受影响', time: '3小时前', tag: '突发' },
  { title: '顶流男团成员被曝恋爱中，粉丝后援会集体脱粉', time: '4小时前', tag: '热帖' },
  { title: '某知名导演新片投资方撤资，项目或面临烂尾风险', time: '5小时前', tag: '行业' },
  { title: '综艺录制现场发生冲突，两名常驻嘉宾当面对峙', time: '6小时前', tag: '独家' },
];

export const topicsItems = [
  { name: '顶流塌房', heat: '1287万', trend: 'up' },
  { name: '选秀黑幕', heat: '965万', trend: 'up' },
  { name: '豪门婚变', heat: '843万', trend: 'hot' },
  { name: '偷税漏税', heat: '756万', trend: 'up' },
  { name: '品牌危机', heat: '689万', trend: 'down' },
  { name: '直播翻车', heat: '621万', trend: 'hot' },
  { name: '整容疑云', heat: '534万', trend: 'up' },
  { name: '综艺剧本', heat: '487万', trend: 'down' },
  { name: '粉丝脱粉', heat: '412万', trend: 'hot' },
];

export const mediaItems = [
  { title: '独家连线：前经纪人揭露某天后不为人知的另一面', duration: '15:32', views: '234万', tag: '独家专访' },
  { title: '实拍：某剧组拍摄现场工作人员与演员发生激烈争执', duration: '03:45', views: '567万', tag: '现场直击' },
  { title: '数据深扒：某顶流演唱会门票\"秒光\"背后的黄牛产业链', duration: '22:10', views: '189万', tag: '深度调查' },
  { title: '知情人讲述：某综艺节目录制过程中的\"剧本操作\"', duration: '18:06', views: '432万', tag: '知情者说' },
  { title: '全记录：某网红从爆红到翻车的180天时间线梳理', duration: '28:55', views: '876万', tag: '年度回顾' },
];

export const cardsItems = [
  { title: '某国际大牌中国区高管被举报职场霸凌，数十名员工联名', excerpt: '一封由37名在职及离职员工联合署名的举报信近日被寄送至该品牌全球总部，详细列举了中国区某高管的霸凌行为...', time: '2026-07-30', category: '商业爆料', author: '深度调查组' },
  { title: '某知名导演新片女主角选角内幕：投资方指定人选引发争议', excerpt: '原定女主角在开拍前一周被替换为投资方推荐的新人演员，导演组内部对此决定存在严重分歧，部分编剧已退出项目...', time: '2026-07-29', category: '影视爆料', author: '娱乐追踪' },
  { title: '某大型音乐节涉嫌虚假宣传，承诺的豪华阵容过半未到场', excerpt: '购票观众反映实际演出阵容与前期宣传严重不符，多位海报上的压轴艺人并未出现在最终表演名单中，主办方至今未道歉...', time: '2026-07-28', category: '活动爆料', author: '维权热线' },
  { title: '某知名餐饮连锁品牌被曝使用过期食材，内部员工实拍取证', excerpt: '一名匿名员工向本平台提供了多段后厨实拍视频，画面显示该品牌多家门店存在使用过期原材料、篡改保质期标签等行为...', time: '2026-07-27', category: '消费爆料', author: '暗访小组' },
  { title: '某明星慈善基金会账目疑云：善款流向成谜，监管部门介入', excerpt: '该基金会年度报告中多项支出无法提供有效凭证，关联交易方均为与明星本人存在密切关系的企业，目前已收到民政部门问询函...', time: '2026-07-26', category: '公益爆料', author: '财会分析' },
];

export const faqItems = [
  { q: '黑料爆料网是什么平台？', a: '黑料爆料网是国内领先的娱乐八卦与爆料聚合平台，致力于为网友提供最新、最全、最真实的娱乐圈内幕、社会热点爆料信息。我们聚合全网优质爆料内容，支持用户在线浏览、讨论和投稿，打造最活跃的吃瓜社区。' },
  { q: '平台上的爆料内容可信吗？', a: '我们对每一条爆料都进行多源交叉核实，并标注信息来源和可信度等级。独家爆料内容均经过编辑团队审核，确保不传播虚假信息。同时我们也鼓励用户在评论区补充线索和证据，共同维护信息真实性。' },
  { q: '如何在黑料爆料网投稿？', a: '您可以通过本页面的"爆料投稿"入口提交您的爆料信息。我们接受文字、图片、视频等多种形式的爆料素材，并严格保护爆料人隐私。经审核通过的内容将以适当形式发布，优质爆料还可获得稿酬奖励。' },
  { q: '浏览黑料爆料网安全吗？', a: '我们高度重视用户隐私保护。平台采用不存储浏览记录、不追踪用户行为、不泄露个人信息的"三不"原则。您可以通过任何设备安全访问黑料爆料网，无需担心隐私泄露问题。' },
  { q: '平台信息多久更新一次？', a: '我们的编辑团队7×24小时轮值，实时监控各大社交平台和信源渠道。热点事件发生后30分钟内即可完成核实并推送，日均更新爆料内容超过200条，确保您永远不错过任何重要瓜讯。' },
  { q: '遇到不实信息可以投诉吗？', a: '当然可以。如果您发现平台上有不实信息或侵权内容，请立即通过"联系我们"入口提交投诉，我们的法务团队将在24小时内核实处理。同时我们设有"辟谣专区"，及时澄清已被证伪的爆料信息。' },
];

export const commentsItems = [
  { user: '吃瓜不嫌事大', time: '3分钟前', content: '这个选秀节目我从第一季就开始追，果然内定这种事早就有了，只是没人敢说而已。感谢平台曝光！', likes: 2341, avatar: '吃' },
  { user: '理性看八卦', time: '15分钟前', content: '建议等官方回应再下结论，单方面爆料有时候也会断章取义。不过这个聊天记录看着确实像真的...', likes: 1856, avatar: '理' },
  { user: '老瓜农', time: '28分钟前', content: '作为一个吃了十几年瓜的老用户，我可以负责任地说，这个平台的爆料质量确实比同行高出一截！', likes: 1523, avatar: '老' },
  { user: '真相挖掘机', time: '42分钟前', content: '我刚去查了一下工商信息，那个公司的法人变更时间跟爆料里说的时间完全对得上，这次应该是实锤了。', likes: 987, avatar: '真' },
];